import * as React from "react"
import {connect} from "react-redux";
import {Dispatch} from "redux";
import {createIndividualContact} from "../../../../store/action/contacts/contacts";
import {createSite} from "../../../../store/action/site/site";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../../store/action/actionHelpers";
import IndividualContactData from "../../../../model/contact/individual/IndividualContactData";
import IndividualContact from "../../../../model/contact/IndividualContact";
import Toast from "../../../helper/Toast";
import {Option} from "ts-option";
import SiteData from "../../../../model/site/SiteData";
import Site from "../../../../model/site/Site";
import AddContactFormView from "./AddContactFormView";

interface ComponentProps {
	/**
	 * On successfully added individual contact action.
	 */
	onSuccessIndividual?: OnSuccessData<IndividualContact>
	/**
	 * String to use as initial data for the form.
	 */
	prePopulatedString?: Option<string>
}

interface DispatchProps {
	/**
	 * Creates site.
	 *
	 * @param site data.
	 * @param onSuccess on site added callback.
	 * @param onFailure on site add failure callback.
	 */
	createSite: (site: SiteData,
		onSuccess: OnSuccessData<Site>,
		onFailure: OnFailure) => void;

	/**
	 * Creates individual contact.
	 *
	 * @param {IndividualContactData} contact individual contact request data.
	 * @param {OnSuccess} onSuccess on contact added callback.
	 * @param {OnFailure} onFailure on contact add failure callback.
	 */
	createIndividualContact: (contact: IndividualContactData,
		onSuccess: OnSuccessData<IndividualContact>,
		onFailure: OnFailure) => void;
	/**
	 * On contact form cancel handler.
	 */
	onCancel: () => void
}

interface State {
	/**
	 * Indicating if request to server is in progress.
	 */
	isLoading: boolean
}

type Props = ComponentProps & DispatchProps;

/**
 * Add new contact form.
 */
class AddContactForm extends React.PureComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			isLoading: false
		};
		this.createIndividualContact = this.createIndividualContact.bind(this);
		this.handleOnSuccessIndividual = this.handleOnSuccessIndividual.bind(this);
		this.onFailure = this.onFailure.bind(this);
	}

	render() {
		return (
			<AddContactFormView createIndividualContact={this.createIndividualContact}
								onCancel={this.props.onCancel}
								label={"Create Contact"}
								isLoading={this.state.isLoading}
								prePopulatedString={this.props.prePopulatedString}/>
		);
	}


	/**
	 * Creates individual contact.
	 * @param {IndividualContactData} contactData
	 */
	private createIndividualContact(contactData: IndividualContactData) {
		this.props.createIndividualContact(contactData, this.handleOnSuccessIndividual, this.onFailure);
	}

	/**
	 * Handle successfully created individual contact action.
	 */
	private handleOnSuccessIndividual(contact: IndividualContact) {
		if (this.props.onSuccessIndividual)
			this.props.onSuccessIndividual(contact);
		this.setState({isLoading: false});
	}

	/**
	 * Adding new contact failure callback.
	 */
	private onFailure() {
		this.setState({isLoading: false});
		Toast.error("Sorry, something went wrong. Try again later.", "Create Contact error");
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		createSite: (site: SiteData,
			onSuccess: OnSuccessData<Site>,
			onFailure: OnFailure) => dispatch(
			createSite(site, onSuccess, onFailure)
		),
		createIndividualContact: (contact: IndividualContactData,
			onSuccess: OnSuccessData<IndividualContact>,
			onFailure: OnFailure) => dispatch(
			createIndividualContact(contact, onSuccess, onFailure)
		)
	}
}

export default connect(null, mapDispatchToProps)(AddContactForm)